import { Injectable } from '@angular/core';
import { Adaptater, ApiHelper, HttpServiceBase } from '@leandredev/common_ng_14';
import { api_collection_plateform } from '@leandredev/dcbm-ng-lib';
import { Observable, ReplaySubject, Subscription, map, of } from 'rxjs';

import { IDataStore } from 'src/app/utils/interfaces';
import { interfaces } from '@leandredev/dcbm-common-lib';
import { ApiService } from '../api/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProxyAdapterService extends Adaptater {
  constructor(private apiService: ApiService) {
    super();
  }

  public fsoUrlResolver(): Observable<string> {
    return of(environment.data.uploadapi);
  }

  public getProxyData(colName: keyof api_collection_plateform, idRef: string): Observable<string> {
    if (!idRef) return of(null);
    return this._getProxyData<string>(colName, idRef);
  }

  private store: Map<string, IDataStore<typeof interfaces>> = new Map();

  private setNewStoreValue<T extends typeof interfaces>(columnName: keyof api_collection_plateform, idObj: string): Subscription {
    const data = this.store.get(idObj) as IDataStore<T>;

    const collection: HttpServiceBase<T> = this.apiService.collections[columnName] as HttpServiceBase<T>;

    return collection
      .get(idObj)
      .pipe(
        ApiHelper.resultToObj('error'),
        map((value: T) => data.value.next(value))
      )
      .subscribe({
        error: (err: Error) => console.warn(columnName, idObj, err.toString())
      });
  }

  public _getProxyData<T extends typeof interfaces>(columnName: keyof api_collection_plateform, idObj: string): Observable<T> {
    if (this.store.has(idObj)) {
      const data = this.store.get(idObj) as IDataStore<T>;

      if (data.callTime < Date.now() - 10000) {
        data.callTime = Date.now();
        this.setNewStoreValue(columnName, idObj);
      }

      return data.value;
    } else {
      const value = new ReplaySubject<T>(1);
      const data = { callTime: Date.now(), value: value };
      this.store.set(idObj, data);

      this.setNewStoreValue(columnName, idObj);
      return value;
    }
  }
}
